import React from "react";
import { Button, Dialog, Row } from "@narmi/design_system";

const noop = () => {};

interface ConfirmModalProps {
  isOpen: boolean;
  onCancel?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  onConfirm?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  onDismiss?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  dataTestId?: string;
  headerText?: string;
  contentText?: string;
  cancelLabel?: string;
  confirmLabel?: string;
}

/**
 * Replaces `Confirm` from semantic-ui-react with an NDS
 * standard Dialog
 */
const ConfirmModal = ({
  isOpen = false,
  onCancel = noop,
  onConfirm = noop,
  onDismiss = noop,
  dataTestId,
  headerText,
  contentText,
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
}: ConfirmModalProps) => (
    <Dialog
      isOpen={isOpen}
      onUserDismiss={onDismiss}
      title={headerText}
      testId={dataTestId}
      footer={
        <Row alignItems="center" justifyContent="end">
          <Row.Item shrink>
            <Button kind="negative" label={cancelLabel} testId="cancel-confirm-modal" onClick={onCancel} />
          </Row.Item>
          <Row.Item shrink>
            <Button kind="primary" label={confirmLabel} testId="confirm-confirm-modal" onClick={onConfirm} />
          </Row.Item>
        </Row>
      }
    >
      <p>{contentText}</p>
    </Dialog>
  );

export default ConfirmModal;
